import auth0 from 'auth0-js';

class Auth0 {
  constructor() {
    const location = window.location;
    const root_url = `${location.protocol}//${location.host}`;
    this.auth0 = new auth0.WebAuth({
      domain: process.env.REACT_APP_AUTH0_DOMAIN || 'lifenome.auth0.com',
      audience:
        process.env.REACT_APP_AUTH0_AUDIENCE || 'https://api.lifenome.com/user',
      clientID:
        process.env.REACT_APP_AUTH0_CLIENT_ID ||
        '813QkMqh8JVC6pN7bEI6cF45xxW5RbJt',
      redirectUri: `${root_url}/auth0-callback`,
      responseType: 'token id_token',
      scope: 'openid email profile',
    });

    this.getProfile = this.getProfile.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  getProfile() {
    return this.profile;
  }

  getAccessToken() {
    return this.accessToken;
  }

  getIdToken() {
    return this.idToken;
  }

  isAuthenticated() {
    return new Date().getTime() < this.expiresAt;
  }

  signIn() {
    this.auth0.authorize();
  }

  signUp() {
    // We have to signalize to Auth0 tthat we would like to get querystring (window.location.search)
    // back to us when Auth0 returns user back to SPARE app.
    const options = {
      appState: { qs: window.location.search },
    };
    if (window.localStorage.getItem('lncovidspareland1') == null) {
      // We have to signalize to Auth0 that we want signup "tab" to be displayed to the user, because
      // we aren't recognizing this user as returning user.
      options.screen_hint = 'signup';
      // Store in local storage a mark when has user visited us for the first time.
      window.localStorage.setItem('lncovidspareland1', new Date());
    }
    this.auth0.authorize(options);
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err) {
          return reject(err);
        }
        if (!authResult || !authResult.idToken) {
          return reject(err);
        }
        this.accessToken = authResult.accessToken;
        this.idToken = authResult.idToken;
        this.profile = authResult.idTokenPayload;
        // set the time that the id token will expire at
        this.expiresAt = authResult.idTokenPayload.exp * 1000;
        resolve(authResult);
      });
    });
  }

  /**
   * Signs user out from Auth0.
   */
  signOut() {
    this.idToken = null;
    this.profile = null;
    this.expiresAt = null;
    this.accessToken = null;
    this.auth0.logout({
      returnTo: window.location.origin + '?loggedOut',
    });
  }
}

const auth0Client = new Auth0();

export default auth0Client;
